export default "__VITE_ASSET__DrwA1roq__"